import { type Common } from '../common.js';
import {
  type InsuranceInformation,
  type InsuranceInformationWithDetails,
} from '../models/patient/insuranceInformation.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/patient-insurance-information';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllWithDetails(
    previsitFormSetId: string,
    fhirCallForPatientInsurances?: boolean
  ): Promise<InsuranceInformationWithDetails[]> {
    const url = this.common.constructPath(this.baseEndpoint, {
      previsitFormSetId,
      fhirCallForPatientInsurances,
    });
    const { patientInsuranceInformations } = await this.common.getJSON(url);
    return patientInsuranceInformations;
  }

  async update(args: {
    insuranceInformationId: string;
    values: Partial<InsuranceInformation>;
    encounterId?: string;
  }): Promise<InsuranceInformation> {
    const { insuranceInformationId, values, encounterId } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${insuranceInformationId}`);
    return await this.common.patchJSON(url, { ...values, encounterId });
  }

  async remove(args: {
    insuranceInformationId: string;
    encounterId?: string;
  }): Promise<{ success: boolean }> {
    const { insuranceInformationId, encounterId } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${insuranceInformationId}`, {
      encounterId,
    });
    return await this.common.deleteJSON(url);
  }

  async recover(args: {
    insuranceInformationId: string;
    encounterId?: string;
  }): Promise<{ success: boolean }> {
    const { insuranceInformationId, encounterId } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${insuranceInformationId}`);
    return await this.common.patchJSON(url, {
      deletedTimestamp: null,
      encounterId,
    });
  }

  async plan(insuranceInformationId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${insuranceInformationId}/plan`);
    return await this.common.postJSON(url, {});
  }

  async choice(args: {
    previsitFormSetId: string;
    payingWithInsurance: boolean;
    skippingInsurance: boolean;
    insuranceFieldId: string;
  }): Promise<{ success: boolean; message: string }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/choice`);
    return await this.common.postJSON(url, args);
  }
}
